import React from 'react';
import { Form, Input, InputNumber } from 'antd';
import { FontSizeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import PhoneInput from '../components/PhoneInput';
import IBAN from "iban"
import { useFormPath } from './index';

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            let Component = Input
            let prefix = "[TEXT]_"
            let type = "text"
            let normalize = undefined

            // Validator helper : transforme la valeur en string avant test, évite crash si number/null
            const patternValidator = (regex, message) => ({
                validator: (_, value) => {
                    if (value === null || value === undefined || value === "") return Promise.resolve()
                    const str = String(value)
                    return regex.test(str) ? Promise.resolve() : Promise.reject(new Error(message))
                }
            })

            switch (data.validation) {
                case formPlugin.VALIDATION[0]: // alphabet
                    rules.push(patternValidator(
                        /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]*$/,
                        t`Le champ doit contenir uniquement des lettres`
                    ))
                    break;
                case formPlugin.VALIDATION[1]: // alphanum
                    rules.push(patternValidator(
                        /^[A-Za-z0-9À-ÖØ-öø-ÿ\s'-]*$/,
                        t`Le champ doit contenir uniquement des chiffres et lettres`
                    ))
                    break;
                case formPlugin.VALIDATION[2]: // num
                    prefix = "[NUMBER]_"
                    Component = InputNumber
                    type = undefined
                    break;
                case formPlugin.VALIDATION[3]: // tel
                    Component = PhoneInput
                    type = undefined
                    break;
                case formPlugin.VALIDATION[4]: // email
                    type = "email"
                    rules.push({
                        type: "email",
                        message: t`L'adresse email n'est pas valide`
                    })
                    break;
                case formPlugin.VALIDATION[5]: // url
                    type = "url"
                    // Pas de rule stricte : Antd type:"url" exige http(s):// ce qui est trop restrictif.
                    // L'attribut type="url" sur l'input fait déjà la validation HTML5 navigateur (souple).
                    break;

                case formPlugin.VALIDATION[6]: // IBAN
                    // Normalisation propre via getValueFromEvent (pas de mutation en pleine validation)
                    normalize = (value) => (value ? IBAN.printFormat(String(value), " ") : value)
                    rules.push({
                        validator: (_, value) => {
                            if (!value || IBAN.isValid(value)) return Promise.resolve()
                            return Promise.reject(new Error(t`Cette IBAN est incorrecte`))
                        }
                    })
                    break;
            }

            const finalName = prefix + data.fieldKey
            const minProp = Component === InputNumber ? { min: 0 } : {}

            return (
                <Form.Item
                    {...(listFieldProps || {})}
                    label={(data.label || t`Question`) + " :"}
                    name={buildName(finalName)}
                    rules={rules}
                    tooltip={tooltip}
                    normalize={normalize}
                >
                    <Component type={type} placeholder={data.placeholder} style={{ width: "100%" }} {...minProp} />
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-plain-text' + namespace,
        title: t`Champ court`,
        description: t`Élément de formulaire utilisable.`,
        icon: <FontSizeOutlined />,
        iconColor: "#F39C12",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },

                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-Étiquette`,
                            placeholder: t`Sous-Étiquette`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                    validation: {
                        type: "string",
                        uniforms: {
                            label: t`Type de Validation`,
                            allowedValues: formPlugin.VALIDATION,
                        }
                    },
                }
            },
        },
    }
}
